import { render, staticRenderFns } from "./Knowledge_check_card.vue?vue&type=template&id=4e7b0aca"
import script from "./Knowledge_check_card.vue?vue&type=script&lang=js"
export * from "./Knowledge_check_card.vue?vue&type=script&lang=js"
import style0 from "./Knowledge_check_card.vue?vue&type=style&index=0&id=4e7b0aca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports